import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

import alert from './alerts'

export const TippyHTML = () => {
  const tippys = document.querySelectorAll('[tippy-html]')

  tippys.forEach((tpy) => {
    const tempDiv = document.createElement('div')
    let setAlert = false
    const input = tpy.getAttribute('tippy-input')

    tempDiv.innerHTML = tpy.nextElementSibling.innerHTML

    tippy(tpy, {
      interactive: true,
      theme: 'white',
      trigger: 'click',
      content: tempDiv,
      arrow: false,
      placement: (input) ? 'top' : "left-end",

      onMount(instance, event) {
        if (!setAlert) {
          tempDiv.querySelectorAll('[alert]').forEach((item) => {
            new alert().confirm(item)
          })
        }

        setAlert = true
      },
    })
  })
}

const Tippy = () => {
  const tippys = document.querySelectorAll('[tippy]')

  if(!tippys.length > 0) return

  tippys.forEach((tpy) => {
    tippy(tpy, {
      theme: 'white',
      trigger: 'click',
      content: tpy.getAttribute('tippy'),
      arrow: false,
    })
  })
}

export default Tippy
